import React from "react";
import Header from "../components/landing/Header";
import { Hero, Benefits } from "../components/landing/HeroSections";
import { Products, Industries, Stats, CtaBanner } from "../components/landing/MidSections";
import Pricing from "../components/landing/Pricing";
import PayFac from "../components/landing/PayFac";
import { Testimonials, Security, Contact, Footer } from "../components/landing/BottomSections";
import WhatsAppButton from "../components/landing/WhatsAppButton";

const Landing = () => {
  return (
    <div className="font-montserrat bg-white min-h-screen">
      <Header />
      <main>
        <Hero />
        <Benefits />
        <PayFac />
        <Products />
        <Industries />
        <Stats />
        <Pricing />
        <CtaBanner />
        <Testimonials />
        <Security />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Landing;
